// extracted by mini-css-extract-plugin
export var avatarContainer = "_3k-1";
export var largeAvatarContainer = "_3k-2";
export var smallAvatarContainer = "_3k-0";